export function computeSurveyResult(answers, surveyType) {
  if (surveyType == "itp") {
    return computeItpResult(answers);
  }
}
export function computeSurveyRadarResult(answers, surveyType) {
  if (surveyType == "itp") {
    return computeItpRadarResult(answers);
  }
}
function computeItpResult(answers) {
  var values = [0, 0, 0, 0, 0];
  Object.keys(answers).forEach(
    (x) => (values[answers[x].value] += answers[x].answer * answers[x].factor)
  );
  // applique la regle de conversion
  var resultRef = "";
  if (values[1] <= 22) resultRef = "E";
  else resultRef = "I";
  if (values[2] <= 22) resultRef += "S";
  else resultRef += "N";
  if (values[3] <= 22) resultRef += "T";
  else resultRef += "F";
  if (values[4] <= 22) resultRef += "J";
  else resultRef += "P";
  return { resultDetails: values, resultRef: resultRef };
}
function computeItpRadarResult(answers) {
  var values = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  Object.keys(answers).forEach((x) => {
    if (answers[x].answer <= 2) {
      values[(answers[x].value - 1) * 2] +=
        (3 - answers[x].answer) * answers[x].factor;
    } else {
      values[(answers[x].value - 1) * 2 + 1] +=
        (answers[x].answer - 2) * answers[x].factor;
    }
  });
  // applique la regle de conversion
  var resultRadar = {
    7: { label: "Extraversion (E)", value: Math.max(values[0] - 2, 0) },
    3: { label: "(I) Introversion", value: values[1] + 3 },
    6: { label: "Sensation (S)", value: Math.max(values[2] - 3, 0) },
    2: { label: "(N) Intuition", value: values[3] + 3 },
    5: { label: "Pensée (T)", value: Math.max(values[4] - 4, 0) },
    1: { label: "(F) Feeling", value: values[5] + 4 },
    4: { label: "Jugement (J)", value: Math.max(values[6] - 1, 0) },
    0: { label: "(P) Perception", value: values[7] + 1 },
  };

  return { resultRadar: resultRadar };
}
